import React from 'react';
import { ShoppingCart } from 'lucide-react';
import '../styles/Navigation.css';

const Navigation = ({ currentPage, setCurrentPage, cartItemsCount }) => {

  // JAVÍTOTT FUNKCIÓ: Kezeli a kosárra kattintást mindkét rendelési oldalon
  const scrollToCart = () => {
    // 1. Eset: Ha valamelyik rendelési oldalon vagyunk (Torta vagy Lepény)
    if (currentPage === 'order' || currentPage === 'lepenyek') {
      const cartElement = document.getElementById('cart-section');
      if (cartElement) {
        cartElement.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 2. Eset: Ha a főoldalon vagyunk, átváltunk a Tortákra (alapértelmezett rendelési oldal)
      setCurrentPage('order');
      
      setTimeout(() => {
        const cartElement = document.getElementById('cart-section');
        if (cartElement) {
          cartElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <nav>
      <div className="logo" onClick={() => setCurrentPage('home')} style={{ cursor: 'pointer' }}>
        KisManó Cukrászda
      </div>
      <div className="nav-links">
        <button 
          className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
          onClick={() => setCurrentPage('home')}
        >
          Főoldal
        </button>

        {/* ÚJ: Lepények menüpont */}
        <button 
          className={`nav-link ${currentPage === 'lepenyek' ? 'active' : ''}`}
          onClick={() => setCurrentPage('lepenyek')}
        >
          Lepények
        </button>

        <button 
          className={`nav-link ${currentPage === 'order' ? 'active' : ''}`}
          onClick={() => setCurrentPage('order')}
        >
          Torták
        </button>
        
        {/* Kosár badge, ami görget vagy oldalt vált */}
        {cartItemsCount > 0 && (
          <button 
            className="cart-badge" 
            onClick={scrollToCart}
            style={{ border: 'none', cursor: 'pointer' }}
          >
            <ShoppingCart size={18} />
            <span style={{ marginLeft: '5px' }}>{cartItemsCount}</span>
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navigation;